function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import ListUser from "./ListUser";
// import ModalUser from "./components/ModalUser/ModalUser";
import { ReactiveBase, ReactiveList, DataSearch, MultiDropdownList, DateRange, SelectedFilters } from "@appbaseio/reactivesearch"; // No idea why visual studio says that this is wrong

import "moment/locale/es";
import MomentLocaleUtils, { formatDate, parseDate } from "react-day-picker/moment";
import _ from "lodash";
import "../../helperComponents/Elasticsearch/elasticsearch.scss";
import "./users.scss";

var IndexUser = function IndexUser(props) {
  var admin = props.admin,
      token = props.token;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      selectedUser = _React$useState2[0],
      setSelectedUser = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      openModal = _React$useState4[0],
      setOpenModal = _React$useState4[1];

  var componentIds = function componentIds() {
    var except = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var filters = ['user_type', 'user_region', 'user_comuna', 'user_phone', 'user_email', 'user_id', 'user_created_at', 'user_updated_at', 'user_birthdate', 'user_classification'];
    return _.without(filters, except);
  };

  var defaultQuery = function defaultQuery() {
    return {
      timeout: "10s",
      query: {
        match_all: {}
      },
      size: 1
    };
  };

  var renderList = function renderList() {
    return /*#__PURE__*/React.createElement(ReactiveList, {
      componentId: "UsersList",
      dataField: "updated_at",
      pagination: true,
      size: 50,
      loader: "Cargando resultados...",
      sortBy: "desc",
      showResultStats: true,
      react: {
        and: componentIds()
      },
      render: function render(_ref) {
        var data = _ref.data;
        return /*#__PURE__*/React.createElement(ReactiveList.ResultListWrapper, {
          style: {
            overflow: "auto"
          }
        }, data.id, /*#__PURE__*/React.createElement(ListUser, {
          users: data,
          onSelectedUser: onSelectedUser,
          admin: admin
        }));
      }
    });
  };

  var onSelectedUser = function onSelectedUser(user) {
    setSelectedUser(user);
    setOpenModal(true);
  };

  var renderOptions = function renderOptions() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement(DataSearch, {
      className: "col-md-4 elasticsearch-component",
      componentId: "user_id",
      dataField: ["id_keyword", "name", "middle_name", "first_surname", "second_surname", "full_name", "rut", "email", "phone", "street", "emails.email", "addresses.street"],
      queryFormat: "and",
      fuzziness: 2,
      title: "Buscar por nombre, RUT, email, tel\xE9fono o direcci\xF3n",
      placeholder: "Buscar usuarios por nombre, RUT, email, tel\xE9fono o direcci\xF3n",
      autosuggest: false,
      react: {
        and: componentIds("user_id")
      }
    }), /*#__PURE__*/React.createElement(MultiDropdownList, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "user_type",
      dataField: "type_text.keyword",
      sortBy: "count",
      showCount: true,
      showMissing: true,
      showFilter: true,
      filterLabel: "Tipo de persona",
      title: "Tipo de persona",
      URLParams: false,
      loader: ".",
      react: {
        and: componentIds("user_type")
      }
    }), /*#__PURE__*/React.createElement(MultiDropdownList, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "user_classification",
      dataField: "classification_text.keyword",
      sortBy: "count",
      showCount: true,
      showMissing: true,
      showFilter: true,
      filterLabel: "Clasificaci\xF3n",
      title: "Clasificaci\xF3n",
      URLParams: false,
      loader: ".",
      react: {
        and: componentIds("user_classification")
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement(MultiDropdownList, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "user_region",
      dataField: "region.name.keyword",
      showCount: true,
      showMissing: true,
      showSearch: true,
      showFilter: true,
      filterLabel: "Regi\xF3n",
      title: "Regi\xF3n",
      URLParams: false,
      react: {
        and: componentIds("user_region")
      }
    }), /*#__PURE__*/React.createElement(MultiDropdownList, {
      className: "col-md-4 elasticsearch-component",
      defaultQuery: defaultQuery,
      componentId: "user_comuna",
      dataField: "comuna.name.keyword",
      showCount: true,
      showMissing: true,
      showSearch: true,
      showFilter: true,
      filterLabel: "Comuna",
      title: "Comuna",
      URLParams: false,
      react: {
        and: componentIds("user_comuna")
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement(DateRange, {
      componentId: "user_birthdate",
      className: "col-md-4 elasticsearch-component",
      dataField: "birthdate",
      title: "Fecha de nacimiento",
      placeholder: {
        start: "Inicio",
        end: "Termino"
      },
      numberOfMonths: 2,
      queryFormat: "date",
      autoFocusEnd: true,
      showClear: true,
      showFilter: true,
      filterLabel: "Fecha de nacimiento",
      dayPickerInputProps: {
        formatDate: formatDate,
        parseDate: parseDate,
        format: "DD/MM/YYYY",
        placeholder: "".concat(formatDate(new Date(), "DD/MM/YYYY", "es")),
        dayPickerProps: {
          locale: "es",
          localeUtils: MomentLocaleUtils
        }
      },
      react: {
        and: componentIds("user_birthdate")
      }
    }), /*#__PURE__*/React.createElement(DateRange, {
      componentId: "user_created_at",
      className: "col-md-4 elasticsearch-component",
      dataField: "created_at",
      title: "Fecha de creaci\xF3n",
      placeholder: {
        start: "Inicio",
        end: "Termino"
      },
      numberOfMonths: 2,
      queryFormat: "date",
      autoFocusEnd: true,
      showClear: true,
      showFilter: true,
      filterLabel: "Fecha de creaci\xF3n",
      dayPickerInputProps: {
        formatDate: formatDate,
        parseDate: parseDate,
        format: "DD/MM/YYYY",
        placeholder: "".concat(formatDate(new Date(), "DD/MM/YYYY", "es")),
        dayPickerProps: {
          locale: "es",
          localeUtils: MomentLocaleUtils
        }
      },
      react: {
        and: componentIds("user_created_at")
      }
    }), /*#__PURE__*/React.createElement(DateRange, {
      className: "col-md-4 elasticsearch-component",
      componentId: "user_updated_at",
      dataField: "updated_at",
      title: "Fecha de \xFAltima actualizaci\xF3n",
      numberOfMonths: 2,
      autoFocusEnd: true,
      showClear: true,
      showFilter: true,
      filterLabel: "Fecha de actualizaci\xF3n",
      queryFormat: "date",
      placeholder: {
        start: "Inicio",
        end: "Termino"
      },
      dayPickerInputProps: {
        formatDate: formatDate,
        parseDate: parseDate,
        format: "DD/MM/YYYY",
        placeholder: "".concat(formatDate(new Date(), "DD/MM/YYYY", "es")),
        dayPickerProps: {
          locale: "es",
          localeUtils: MomentLocaleUtils
        }
      },
      react: {
        and: componentIds("user_updated_at")
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement(SelectedFilters, {
      className: "elasticsearch-component",
      showClearAll: true,
      clearAllLabel: "Limpiar filtros"
    })));
  };

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ReactiveBase, {
    app: "users",
    url: "".concat(process.env.SEGUROS_API_URL),
    headers: {
      "X-CSRF-Token": token
    }
  }, /*#__PURE__*/React.createElement("aside", null, renderOptions()), renderList()));
};

export default IndexUser;